module.exports = __webpack_public_path__ + "img/538738.0bb8ce3b.png";